module.exports = __webpack_public_path__ + "img/female-youngchild-hand.26c3e9e0.svg";